import PropTypes from 'prop-types';

import companiesStrings from 'modules/companies/strings';

import { Wrapper, AddCompanyBtn } from './CompaniesHeader.style';

const CompaniesHeader = ({ handleAddCompanyBtnClick }) => (
  <Wrapper>
    <AddCompanyBtn as="button" onClick={handleAddCompanyBtnClick}>
      {companiesStrings.companiesHeader.addCompanyBtn}
    </AddCompanyBtn>
  </Wrapper>
);

CompaniesHeader.propTypes = {
  handleAddCompanyBtnClick: PropTypes.func.isRequired,
};

export default CompaniesHeader;
